export default __webpack_public_path__ + "static/media/04-MomentFactory-Logo.07dec684.jpg";